/** A trailing `Z` or a `±HH:MM` / `±HHMM` offset — a timestamp that states its zone. */
const ZONED_SUFFIX = /(?:Z|[+-]\d{2}:?\d{2})$/i

/**
 * A span timestamp as a UTC instant.
 *
 * The backend sends them without a zone — `"2026-09-11 22:16:06.700453000"` —
 * and `Date.parse` reads a zone-less timestamp as local time. Relative maths
 * survives that, because every span is shifted alike, but the moment one is
 * compared against an instant that does state its zone — a recording's start
 * time, say — the reader's own UTC offset lands in the answer. West of
 * Greenwich that made every trace look hours adrift from its audio.
 *
 * Stamping the zone as the spans arrive gives the whole viewer one reading of
 * when a span happened. A timestamp that already names its zone is left alone.
 */
export function normalizeTraceTimestamp(timestamp: string): string {
  const trimmed = timestamp.trim()
  if (!trimmed || ZONED_SUFFIX.test(trimmed)) {
    return trimmed
  }

  // Only a timestamp carrying a time of day can be stamped: a bare date is
  // already read as UTC.
  const isoLike = trimmed.replace(" ", "T")
  if (!isoLike.includes("T")) {
    return trimmed
  }

  return `${isoLike}Z`
}
